var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailSharingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161204",
    "data-name": "Group 161204",
    transform: "translate(-894 -785)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161203",
    "data-name": "Group 161203",
    transform: "translate(0 417)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1899",
    "data-name": "Rectangle 1899",
    width: 100,
    height: 100,
    rx: 19,
    transform: "translate(894 368)",
    fill: "#f4f4fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "email-envelope-message-padlock-locked-secured-svgrepo-com",
    transform: "translate(913 804)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2292",
    "data-name": "Path 2292",
    d: "M3,10,28.4,25.629,53.8,10",
    transform: "translate(0 4.768)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1972",
    "data-name": "Rectangle 1972",
    width: 22.97,
    height: 14.931,
    transform: "translate(35.772 41.349)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2293",
    "data-name": "Path 2293",
    d: "M35.676,28.952H22V24.388A6.706,6.706,0,0,1,28.838,18h0a6.706,6.706,0,0,1,6.838,6.388Z",
    transform: "translate(18.119 12.398)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2294",
    "data-name": "Path 2294",
    d: "M27.818,47.98h-17A7.838,7.838,0,0,1,3,40.166V12.815A7.838,7.838,0,0,1,10.815,5H45.98A7.838,7.838,0,0,1,53.8,12.815V23.208",
    transform: "translate(0)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSharingIcon);
export default __webpack_public_path__ + "static/media/email-sharing-icon.1baae436c6fa1402d5e4d07c39ce8a85.svg";
export { ForwardRef as ReactComponent };